import { getHistoryItemsFromResponse } from '../../utils/parse-history';
import { apiClient } from '../core/client';

export const addPartnerHistory = async ({ log_partner_id }) => {
  const res = await apiClient(
    `${process.env.REACT_APP_API_URL}telemetry_dashboard_data/search-history/`,
    {
      method: 'POST',
      body: JSON.stringify({
        log_partner_id: log_partner_id
      })
    }
  );

  return res.json();
};

export const fetchPartnerHistory = async ({ association_type }) => {
  const res = await apiClient(
    `${process.env.REACT_APP_API_URL}telemetry_dashboard_data/search-history/?search=${association_type}`
  );
  const history = await res.json();

  return getHistoryItemsFromResponse(history);
};
